export function isDefined<T>(value: T): value is NotUndefined<T> {
  return typeof value !== 'undefined';
}
